import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FormInput } from 'components/input/hook-form';
import { useForm, Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import * as yup from 'yup';
import { format } from 'date-fns';
import {
    useDeleteWorkCalendarApiMutation,
    useGetWorkCalendarByIdApiQuery,
    useUpdateWorkCalendarApiMutation
} from 'lib/api/admin/adminWorkCalendar';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { useState } from 'react';
import TableLoader from 'components/loader/TableLoader';

interface IDetailWorkEventDialogProps {
    open: boolean;
    handleClose: () => void;
    id?: string | null;
}

interface DetailWorkEventFormValues {
    title: string;
    date: dayjs.Dayjs;
}

const DetailWorkEventDialog = ({ open, handleClose, id }: IDetailWorkEventDialogProps) => {
    const [loading, setLoading] = useState(false);
    const [updateWorkCalendar] = useUpdateWorkCalendarApiMutation();
    const [deleteWorkCalendar] = useDeleteWorkCalendarApiMutation();
    const { data: workEvent, isLoading: workEventIsLoading } = useGetWorkCalendarByIdApiQuery({
        id: id ?? ''
    });
    const { handleSubmit, control, setValue } = useForm<DetailWorkEventFormValues>({
        mode: 'onSubmit',
        values: {
            title: workEvent?.data?.title || '',
            date: workEvent?.data?.date ? dayjs(workEvent?.data?.date) : dayjs()
        },
        resolver: yupResolver(
            yup
                .object({
                    title: yup.string().required('*Title is required'),
                    date: yup.date().required('*Date is required')
                })
                .required()
        )
    });

    const onDelete = () => {
        if (!id) return;
        setLoading(true);
        deleteWorkCalendar({
            id
        })
            .unwrap()
            .then(() => {
                setLoading(false);
                withReactContent(Swal).fire('Sukses', 'Berhasil menghapus data!', 'success');
            })
            .catch((error) => {
                console.error('Error deleting work event:', error);
            })
            .finally(() => {
                setLoading(false);
                handleClose();
            });
    };

    const onSubmit = (data: DetailWorkEventFormValues) => {
        if (!id) return;
        setLoading(true);
        updateWorkCalendar({
            id: id,
            title: data.title,
            date: format(new Date(data.date.toISOString()), 'yyyy-MM-dd')
        })
            .unwrap()
            .then(() => {
                setLoading(false);
                withReactContent(Swal).fire('Sukses', 'Berhasil mengedit data!', 'success');
            })
            .catch((error) => {
                console.error('Error updating work event:', error);
            })
            .finally(() => {
                setLoading(false);
                handleClose();
            });
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            {workEventIsLoading ? (
                <TableLoader />
            ) : (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div>
                            <DialogTitle variant="h3">Detail Holiday</DialogTitle>
                            <DialogContent>
                                <Grid container spacing={20} direction={'column'}>
                                    <Grid item>
                                        <FormInput control={control} label="Title" type="text" name="title" />
                                    </Grid>
                                    <Grid item>
                                        <Controller
                                            name="date"
                                            control={control}
                                            render={({ field }) => (
                                                <>
                                                    <Typography variant="caption" sx={{ pDetailingTop: '0', marginTop: '0' }}>
                                                        Holiday Date
                                                    </Typography>
                                                    <MobileDatePicker
                                                        value={field.value}
                                                        slotProps={{ textField: { fullWidth: true } }}
                                                        onChange={(date: dayjs.Dayjs | null) => {
                                                            if (date) {
                                                                setValue('date', date, { shouldValidate: true });
                                                            }
                                                        }}
                                                    />
                                                </>
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button size="large" color="error" onClick={onDelete} disabled={loading}>
                                    Delete
                                </Button>
                                <Button size="large" type="submit" disabled={loading}>
                                    Update
                                </Button>
                            </DialogActions>
                        </div>
                    </form>
                </LocalizationProvider>
            )}
        </Dialog>
    );
};

export default DetailWorkEventDialog;
